// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"5faa99a7","319":"a742976c","410":"4db5eba7","440":"62811538","455":"96732250","488":"45e9765a","503":"dbc765b7","593":"117b5765","612":"34924881","733":"88c1afaa","860":"43d4ae00","883":"4906cfc1","953":"a8b65023","977":"0710e8a8"}[chunkId] + ".chunk.js";
};